import { useSettingData } from "../data/use-settings-data";
import { useGroupUuid } from "./use-group-uuid";

export function useSharedGroupUuid() {
  const groupUuid = useGroupUuid();
  return useSettingData(groupUuid, "SHARED_WORKSPACE_UUID").value;
}
